import { render } from "./ListDialog.vue?vue&type=template&id=0b53f9c2"
import script from "./ListDialog.vue?vue&type=script&lang=js"
export * from "./ListDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__